/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Past from './Past/index'
import React from 'react'
import Upcoming from './Upcoming/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/Tabs"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Tabs.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-brpv': dtColorsWhite,'--pl-2-brpv': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-3-brpv': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btc-4-brpv': dtColorsNeutral200,'--bbc-5-brpv': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Upcoming
  viewPath={`${viewPath}/Upcoming`}
/>
<Past
  viewPath={`${viewPath}/Past`}
/>
</div>
{children}
</React.Fragment>)
}